import styled from '../../../config/theme'

const Container = styled.div`
  padding: 20px;
  overflow: auto;
`

const Select = styled.select`
  font-size: ${props => props.theme.fontSize.regular};
  border: 1px solid ${props => props.theme.color.lightGray};
  color: ${props => props.theme.color.darkGray};
  border-radius: 4px;
  padding: 8px 16px;
  padding-right: 32px;

  position: relative;

  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;

  background: white;

  + span {
    content: '';
    position: absolute;
    z-index: 2;
    top: 20px;
    right: 8px;
    margin-top: -3px;
    height: 0;
    width: 0;
    border-top: 6px solid #414141;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    pointer-events: none;
  }
`

const StatusButtons = styled.div`
  @media screen and (min-width: 800px) {
    display: flex;
    justify-content: space-between;
    margin: 0 -10px;
    > * {
      flex-grow: 1;
      margin: 0 10px;
    }
    > *:first-child:last-child {
      width: 50%;
      flex-grow: 0;
    }
  }

  > * {
    display: block;
    width: 100%;
    margin-bottom: 5px;
  }
`

export {
  Container,
  Select,
  StatusButtons
}
